import { stream } from 'exceljs';

export class SystemSettingConfig {

  AdminName: string;
  DBType: string;
  DB_Name: string;
  UserName: string;
  Pin: string;
  Port: string;
  //DBPath: string;
  //ByPassPin: string;
  LinkKeyword: string;
  FailureCalls: string;
  GoogleMapsAPIKey: string;
  GoogleMapID_AdvancedMarker: string;
  GPSReplace: string;
  EmailID: string;
  HostServerIP: string;
  //SortEvents: string;
  //CallTypeTerminating: string;
  //OutPutGPSFormat: string;
  //OutPutTimestampFormat: string;
  //SendConfigToScheduler: string;
  DB_IP: string;
  LoginType: string;
  ForgotPasswodKey: string;
  OldPin: string;
}
